
import React, { Component } from 'react';
import { InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import './alarmPage.less';
import sensor from "../../../imgs/item/sensor.png";
import arrow_right from "../../../imgs/btn/arrow_right.png";
import arrow_down from "../../../imgs/btn/arrow_down.png";
import group from "../../../imgs/item/group.png";
import warn from "../../../imgs/mesh/warn.png";
import montion from "../../../imgs/item/montion.png";
import { getGroupNormalImgWithName,getGroupSelectImgWithName } from '../../../utils/fileUtils';
import { getAllGroupsAndDevices } from '../../../utils/meshUtils';
import { meshLog } from '../../../utils/spUtils';

export default class AlarmPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: '',
            item1_list: [
                { name: 'Sensor', icon: 'file' },
                { name: 'Emergency Control', icon: 'lightbulb' },
                { name: 'Measuring equipment', icon: 'user' }
            ],
            groups: [],
            devices: [],
        };
    }

    componentDidMount() {
        this.setState({ groups: getAllGroupsAndDevices() });
            
    }

    groupArrowClick = (mId) => {
        let arr = this.state.groups;
        // meshLog('groups', arr,mId);
        let arrD = [];
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == mId) {
                arr[i].checked=!arr[i].checked;
                if(arr[i].checked){
                    arrD=arr[i].devices;
                }else{
                    arrD=[];
                }
            }else{
                arr[i].checked=false;
            }
        }
        meshLog('groups', mId,arrD);
        this.setState({
            groups: arr,
            devices: arrD,
        });
    };


    render() {
        return (
            <div className="alarm-page-container">
                {/* 1. Area Management 标题行 */}
                <div className="alarm_header">
                    <span>Fault Alarm</span>
                    {/* <InfoCircleOutlined className="header-icon" /> */}
                </div>

                <div className="alarm_item1">
                    <div className="item_row">
                        <div className="item_title">
                            <img className='icon' src={sensor}/>
                            <span>Device Type</span>
                        </div>    
                        {/* <img className="arrow" src={arrow_down} /> */}
                    </div>
                    <div className="item1-list">
                        {this.state.item1_list.map((item) => (
                            <div key={item.name} className="item1_info">
                                <span>{item.name}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="alarm_item2">
                    <div className="item_row">
                        <div className="item_title">
                            <img className='icon' src={group}/>
                            <span>Group Type</span>
                        </div>
                        {/* <img className="arrow" src={arrow_down} /> */}
                    </div>
                    <div className="alarm_group_list">
                        {this.state.groups.map((group) => (
                            <div key={group.id} className="group_alarm">
                                <div className='group_title' onClick={() => { this.groupArrowClick(group.id) }}>
                                    <img className='item_icon' src={group.checked ? getGroupSelectImgWithName(group.icon) : getGroupNormalImgWithName(group.icon)} />
                                    <span style={{ color: group.checked ? "#0B47BE" : "#595757" }}>{group.name}</span>
                                    <img className='group_warn' src={warn} style={{ display: group.isWarning ? "flex" : "none" }}/>
                                    <img className='arrow' src={group.checked ? arrow_down : arrow_right} />
                                </div>
                                <div className='devices_alarm' style={{ display: group.checked ? "flex" : "none" }}>
                                    {this.state.devices.map((device,index) => (
                                        <div key={device.macAddress} className="device_item">
                                            <div className='device_left'>
                                                <img className='device_icon' src={montion} />
                                                <span>{device.name}</span>
                                                <img className='device_warn' src={warn} style={{ display: index<=1 ? "flex" : "none" }}/>
                                            </div>
                                            <div className='device_right'>
                                                
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        ))}
                    </div>
                </div>

                
            </div>
        );
    }
}

